import { useAuth } from "@/auth"

import { Navigate } from "@be-miniapp/ui/components/navigate"

const RootScreen = () => {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) return <Navigate to="/unauthorized" />

  return <Navigate to="/ride/home" />
}

export { RootScreen }
